import {
    Language,
    Translator,
    genericEN,
    genericNL
  } from "@cak-legacy/shared-locales";
  
  const translator = new Translator();
  translator.registerTranslations(Language.English, genericEN);
  translator.registerTranslations(Language.Nederlands, genericNL);
  
  export const translate = (key: string, properties: { [key: string]: string } = {}): string => {
    return translator.translate(key, properties);
  };
  